import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import DataTable from '../../common/components/DataTable';
import LargeUserPill from '../../common/components/LargeUserPill';
import UserPill from '../../common/components/UserPill';
import { Icon } from '../../common/components/Utilities';
import PeopleLayout from '../layout/PeopleLayout';
import DataSelect from '../../common/components/DataSelect';
import JobSelect from '../../common/components/DataSelect/JobSelect';
import { CreateButton, EditButton } from '../../common/components/Buttons';

function UsersPage(props) {
  let action;

  if (props.activeUser.isOps) {
    action = (
      <CreateButton href="/users/create" icon="user-plus">Add Person</CreateButton>
    );
  }

  return (
    <PeopleLayout
      {...props}
      action={action}
      content={<UsersList {...props} />}
    />
  );
}

function UsersList({ filters, activeUser }) {
  const defaultFilters = filters;
  defaultFilters.with = ['job', 'manager'];

  const [activeFilters, setFilters] = useState(defaultFilters);

  const renderRow = (user) => {
    let action;

    if (activeUser.isOps) {
      action = (
        <EditButton href={`/users/${user.id}/edit`} style={{ whiteSpace: 'nowrap' }} size="sm" />
      );
    }

    return (
      <tr key={user.id}>
        <td>
          <LargeUserPill user={user} />
        </td>
        <td>
          <UserPill user={user.manager} />
        </td>
        <td>{action}</td>
      </tr>
    );
  };

  return (
    <>
      <UserFilters filters={activeFilters} setFilters={setFilters} />
      <DataTable
        url="/resource/users"
        filters={activeFilters}
        columns={['Name', 'Team Lead', '']}
        renderRow={renderRow}
        noResultsMessage="Sorry, we couldn't find any users."
      />
    </>
  );
}

function UserFilters({ filters, setFilters }) {
  const [show, setShow] = useState(false);

  const setFilter = (key, value) => {
    const newFilters = { ...filters };
    newFilters[key] = value;
    setFilters(newFilters);
  };

  return (
    <>
      <Button
        onClick={() => setShow(true)}
        variant="outline-secondary"
        size="sm"
        style={{
          position: 'absolute', right: '27px', top: '5px', zIndex: 1000,
        }}
      >
        <Icon icon="filter" />
      </Button>

      <Modal size="sm" show={show} onHide={() => setShow(false)}>
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>Filter People</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <h3 style={{ fontSize: '1.2em' }}>Started</h3>
            <select className="form-control" defaultValue={filters.not_started} onChange={(event) => setFilter('not_started', event.target.value)}>
              <option value="" />
              <option value="1">Not Started</option>
              <option value="0">Started</option>
            </select>

            <h3 style={{ fontSize: '1.2em' }}>Start Month</h3>
            <input type="month" className="form-control" onChange={(event) => setFilter('start_month', event.target.value)} />

            <h3 style={{ fontSize: '1.2em' }}>Squad</h3>
            <DataSelect
              noneTitle="All Squads"
              url="/squads/list"
              titleKey="name"
              value={filters.squad_id}
              onChange={(event) => setFilter('squad_id', event.target.value)}
            />

            <h3 style={{ fontSize: '1.2em' }}>Job</h3>
            <JobSelect
              noneTitle="All Job Types"
              value={filters.job_id}
              onChange={(event) => setFilter('job_type_id', event.target.value)}
            />

            <h3 style={{ fontSize: '1.2em' }}>Skill</h3>
            <DataSelect
              noneTitle="All Skills"
              name="skill_id"
              url="/resource/skills"
              titleKey="title"
              value={filters.skill_id}
              onChange={(event) => setFilter('skill_id', event.target.value)}
            />

            <h3 style={{ fontSize: '1.2em' }}>Location</h3>
            <select
              className="form-control"
              value={filters.location_id}
              onChange={(event) => setFilter('location_id', event.target.value)}
            >
              <option value="">All Locations</option>
              <option value="1">Manchester</option>
              <option value="2">York</option>
            </select>

            <h3 style={{ fontSize: '1.2em' }}>Probation</h3>
            <select
              className="form-control"
              value={filters.probation_passed}
              onChange={(event) => setFilter('probation_passed', event.target.value)}
            >
              <option value="" />
              <option value="1">Passed</option>
              <option value="0">In Probation</option>
            </select>

          </Modal.Body>
        </Form>
      </Modal>
    </>
  );
}

export default UsersPage;
